const distinct = <TSource, TCriteria>(source: TSource[], select: (x: TSource) => TCriteria): TCriteria[] => {

    return (
        source
            .filter((x, i, array) => array.findIndex(y => select(y) === select(x)) === i)
            .map(select)
    );
};

export default distinct;